/* eslint-disable */
import React, { useState, useEffect, useRef} from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import "../../styles/challanlist.css";
import "../../styles/time_table_management.css";
import { uploadTimeTableCsv, resetTimeTableList, getTimetableCsvErrList, admitCardSampleCsvDownload, getActiveExamList, getExamTemplateListForImportAdmitCardCsvAPI, getExamCenterListAPI } from '../../timetablemanagement/actions/timetableManagementAction';
import TimeTableLabels from "../labels/timetable_en.json";
import commonLabels from '../../common/labels/common_en.json';
import _ from "lodash/fp";

const TimeTableCsvImport = (props) => {
    const { register, errors, formState, reset} = useForm({
        mode: "onChange"
    });

    const { uploadTimeTableCsvErrList, uploadTimeTableCsvErrResponse, getActiveExamListData, getExamTemplateListForImportAdmitCardCsv, getExamCenterList } = useSelector(
        (state) => state.timeTableManagementReducer,
        shallowEqual
    );
    const fileInputRef = useRef(null);
    let [file, setFile] = useState("");
    const dispatch = useDispatch();
    const [csvErr, setCsvErr] = useState("");
    const [showBtn, setShowBtn] = useState(false);
    const [errorFileName, setErrorFileName] = useState("");
    const [examTemplate, setExamTemplate] = useState("");
    const [selectedExam, setSelectedExam] = useState("");
    const [examCenter, setExamCenter] = useState("");
    const [isValidate,setIsValidate]=useState("");
    useEffect(() => {
        props && props.advtId && dispatch(getActiveExamList(props.advtId));
        props && props.advtId && dispatch(getExamCenterListAPI(props.advtId));
        dispatch(resetTimeTableList());
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (uploadTimeTableCsvErrResponse && uploadTimeTableCsvErrResponse.errorInUploadedFile) {
            setShowBtn(true);
        }
    }, [uploadTimeTableCsvErrResponse]);

    const onChangeImage = (event) => {
        setCsvErr("");
        setShowBtn(false);
        if (event.target.files.length == 0) {
            return
        }
        setFile(event.target.files[0])
    }


    const uploadFile = () => {
        let data = {};
        data.file = file;
        data.action = 'upload';
        data.validateVenue=isValidate;
        const fileName = file.name;
        const currentDateTime = new Date();
        const year = currentDateTime.getFullYear();
        const month = (currentDateTime.getMonth() + 1).toString().padStart(2, "0");
        const day = currentDateTime.getDate().toString().padStart(2, "0");
        let hours = currentDateTime.getHours();
        let minutes = currentDateTime.getMinutes();
        let period = "AM";

        if (hours >= 12) {
            period = "PM";
            hours -= 12;
        }

        hours = hours === 0 ? 12 : hours;
        minutes = minutes.toString().padStart(2, "0");

        const errorfilename = fileName + "_" + year + month + day + "_" + hours + ":" + minutes + period;
        setErrorFileName(errorfilename);
        if (data.file !== "") {
            setCsvErr("");
            dispatch(uploadTimeTableCsv(data, props.stageId, errorfilename, examCenter, examTemplate))
        }
        else {
            setCsvErr("This field is required");
        };
        setFile("")
        setShowBtn(false);
        setExamCenter("");
        setSelectedExam("");
        setExamTemplate("");
        delete uploadTimeTableCsvErrList.timeTableCsvDtoList;
        getExamTemplateListForImportAdmitCardCsv.length = 0;
        if(fileInputRef.current){
            fileInputRef.current.value = "";
        }
    };

    const cancelModal = () => {
        dispatch(resetTimeTableList());
        props.setImportumentList(false);
        setFile("");
        setCsvErr("");
        setShowBtn(false);
        setSelectedExam("")
        setExamCenter("");
        setIsValidate("");
        delete uploadTimeTableCsvErrList.timeTableCsvDtoList;
        getExamTemplateListForImportAdmitCardCsv.length = 0;
    }

    const handleInputClick = () => {
        setFile("");
        delete uploadTimeTableCsvErrList.timeTableCsvDtoList;
    };

    const handleDownloadCsvFile = () => {
        let errorfilename = errorFileName;
        dispatch(getTimetableCsvErrList(errorfilename, file))
    };

    const downloadSampleCsvClick = () => {
        dispatch(admitCardSampleCsvDownload())
    }

    const handleExamChange = (e) => {
        let examid = e.target.value;
        setSelectedExam(examid);
        setExamTemplate("");
        if(examid){
        dispatch(getExamTemplateListForImportAdmitCardCsvAPI(examid));
        };
        getExamTemplateListForImportAdmitCardCsv.length = 0;
    };

    const handleExamCenterChange = (e) => {
        let examCenterId = e.target.value;
        setExamCenter(examCenterId);
    };

    const onValidateVenue=(e)=>{
        setIsValidate(e);
    }
    return (
        <div>
            <Modal size="xl" show={props.showImportList} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static' >
                <Modal.Header  className="d-flex justify-content-between align-items-center logout_heading">
                    <Modal.Title className='logout_title'>{TimeTableLabels.IMPORT_TIME_TABLE_CSV_FILE}</Modal.Title>
                      <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={cancelModal}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className='row'>
                            <div className='col-md-4'>
                                <label className="text-left">{TimeTableLabels.SELECT_EXAM}<span className="errorText">*</span></label>
                                <div className="input-group bg-color">
                                    <select
                                    className='form-select bg-color'
                                    name="selectedExam"
                                    value={selectedExam}
                                    defaultValue={selectedExam}
                                    onInput={handleExamChange}
                                    ref={register({ required: true })}
                                >
                                    <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                                    {getActiveExamListData && getActiveExamListData.length > 0 && getActiveExamListData.filter(element => element.isDeleted == false).map((element, index) =>
                                        <option key={index} value={element.id}>{element.name}</option>
                                    )}
                                    </select>
                                </div>
                                {_.get("selectedExam.type", errors) === "required" && (
                                    <p className="errorText float-left mt-n4">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                                )}
                            </div>

                            <div className='col-md-4'>
                                <label className="text-left">{TimeTableLabels.SELECT_EXAM_TEMPLATE}<span className="errorText">*</span></label>
                                <div className="input-group bg-color">
                                    <select
                                        className='form-select bg-color'
                                        name="examTemplate"
                                        value={examTemplate}
                                        defaultValue={examTemplate}
                                        onInput={(e) => { setExamTemplate(e.target.value) }}
                                        ref={register({ required: true })}
                                    >
                                        <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                                        {getExamTemplateListForImportAdmitCardCsv && getExamTemplateListForImportAdmitCardCsv.length > 0 && getExamTemplateListForImportAdmitCardCsv.sort((a, b) => { return Number(a.sortOrder) - Number(b.sortOrder) }).map((ele, ind) => {
                                            return <option key={ind++} value={ele.id}>{ele.label}</option>
                                        })}
                                    </select>
                                </div>
                                {_.get("examTemplate.type", errors) === "required" && (
                                    <p className="errorText float-left mt-n4">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                                )}
                            </div>

                            <div className='col-md-4'>
                                <label className="text-left">{TimeTableLabels.EXAM_CENTER}<span className="errorText">*</span></label>
                                <div className="input-group bg-color">
                                    <select
                                        className='form-select bg-color'
                                        name="examCenter"
                                        value={examCenter}
                                        defaultValue={examCenter}
                                        onInput={handleExamCenterChange}
                                        ref={register({ required: true })}
                                    >
                                        <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                                        {getExamCenterList && getExamCenterList.length > 0 && getExamCenterList.map((element, index) =>
                                            <option key={index} value={element.id}>{element.name}</option>
                                        )}
                                    </select>
                                </div>
                                {_.get("examCenter.type", errors) === "required" && (
                                    <p className="errorText float-left mt-n4">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                                )}
                            </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4 mb-4 mt-3 d-grid'>
                                    <label className="float-left">{TimeTableLabels.UPLOAD} {TimeTableLabels.FILE}<span className="errorText">*</span></label>
                                    <input
                                        className='bg-color'
                                        type="file"
                                        accept='.csv'
                                        onChange={(event) => onChangeImage(event)} onClick={handleInputClick} ref={(e) => {register({ required: true })(e); fileInputRef.current = e;}}
                                    />
                                    {csvErr !== "" && <p className="errorText mt-n4">{csvErr}</p>}
                                </div>

                                <div className='col-md-4 mb-4 mt-3 d-flex flex-column'>
                                    <label className="float-left">{TimeTableLabels.validateVenue}</label>
                                    <input
                                        className='f12 w-10 h-50 mt-1'
                                        type="checkbox"
                                        id="activeValue"
                                        name="activeValue"
                                        checked={isValidate}
                                        onChange={(event) => onValidateVenue(event.target.checked)}
                                    />
                                </div>

                        </div>
                        <div className='row'>
                            <div className='col-md-1 mt-2 mr-n5'>
                                <button type="button" onClick={uploadFile} className="  btn btn-primary custom_button  btn-sm cursor-pointer ml-2 pt-1 pb-1" disabled={(!formState.isValid) || (!examTemplate) || (!file)}>
                                    {TimeTableLabels.UPLOAD}
                                </button>
                            </div>

                            <div className='col-md-2 mt-2'>
                                <button type="button" onClick={downloadSampleCsvClick} className="  btn btn-primary custom_button  btn-sm cursor-pointer ml-2 pt-1 pb-1">
                                    {TimeTableLabels.DOWNLOAD_SAMPLE_FILE}
                                </button>
                            </div>

                            {showBtn &&
                                <div className='col-md-2 mt-2 ml-n5'>
                                    <button type="button" onClick={handleDownloadCsvFile} className="  btn btn-primary custom_button  btn-sm cursor-pointer ml-2 pt-1 pb-1">
                                        {TimeTableLabels.DOWNLOAD_CSV}
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={cancelModal} >{commonLabels.BUTTON_CANCEL}</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default TimeTableCsvImport;


